import React, { useEffect } from 'react';

export interface IMortgageLandingProps {
  regionid?: number;
  loanterm?: number;
  propertyamount?: number;
  initialpayment?: number;
  realtytype?: string;
  pagetype?: string;
}

export const MortgageLanding = (props: IMortgageLandingProps) => {
  useEffect(() => {
    const widgetJs = '//cdn.cian.site/finance/mortgage-landing-widget/widget.js';
    if (!document.querySelector(`script[src='${widgetJs}']`)) {
      const script = document.createElement('script');
      script.src = widgetJs;
      script.async = true;
      document.head.appendChild(script);
    }
  }, []);

  return React.createElement('mortgage-landing-widget', props);
};
